import React, { createContext, useContext, useEffect, useState } from 'react';
import CommonModal from '../components/Modal/CommonModal';
import { NO_LAYOUT_ROUTH_PATH } from '../routes';
import { useLocation } from 'react-router-dom';
import Layout from '../layout';
import LoadingPage from '../components/LoadingPage';

const UIContext = createContext(null);

export const UIProvider = ({ children }) => {
  const [contextLoading, setContextLoading] = useState(true);
  const [modalData, setModalData] = useState(null);
  const [pageTitle, setPageTitle] = useState('');
  const location = useLocation(); // 현재 경로 가져오기

  // 현재 경로가 로딩이 필요한 경로인지 확인
  const isLoadingRequiredPath = NO_LAYOUT_ROUTH_PATH.includes(
    location.pathname
  );

  useEffect(() => {
    if (isLoadingRequiredPath) {
      setContextLoading(true);
    }
  }, [location.pathname]);

  return (
    <UIContext.Provider
      value={{
        contextLoading,
        setContextLoading,
        modalData,
        setModalData,
        pageTitle,
        setPageTitle,
      }}
    >
      {contextLoading && isLoadingRequiredPath && <LoadingPage />}

      {children}

      {!!modalData && (
        <CommonModal
          showModal={!!modalData}
          setShowModal={() => setModalData(null)}
          modalData={modalData}
        />
      )}
    </UIContext.Provider>
  );
};

export const useUI = () => {
  const context = useContext(UIContext);
  if (context === undefined) {
    throw new Error('useUI must be used within a UIProvider');
  }
  return context;
};
